// extracted by mini-css-extract-plugin
module.exports = {"token":"PromotedToken_token__YMt8w","icon":"PromotedToken_icon__39Jk5"};